import {CustomCode} from "../../../model/common.model";

export class CareerDetailType extends CustomCode {

    private static _registered = new Map<string,CareerDetailType>();

    static TRAINING = new CareerDetailType('TRAINING');
    static COACHING = new CareerDetailType('COACHING');
    static SPECIAL_PROJECT = new CareerDetailType('SPECIAL_PROJECT');
    static OTHER = new CareerDetailType('OTHER');

    static ALL = Array.from(CareerDetailType._registered.values());

    constructor(code: string) {
        super(code);
        CareerDetailType._registered.set(code, this);
    }


    public toString(): string {
        return this.code;
    }


    static retrieveFromCode(code: string): CareerDetailType {
        const res = CareerDetailType._registered.get(code);
        if (!res) {
            console.log('Hmmm CareerDetailType can\'t find ' + code);
        }
        return res;
    }


    public toTranslateKey(): string{
        return 'CAREER_DETAIL_TYPE_' + this.code;
    }

}